import { ServicesSoldTable } from './components/services-sold-table/ServicesSoldTable';

const Sales = () => {
  return (
    <div className="w-full">
      <ServicesSoldTable />
    </div>
  );
};

export default Sales;
